import React from 'react'
import { observer, inject } from 'mobx-react'
import SelectWithLoader from '../../../common/SelectWithLoader'

const DataSourceSelect = ({ uiStore, rightSidebarStore }) => {
  if (!uiStore) {
    return null
  }
  return (
    <SelectWithLoader
      isCompact
      styles={{
        control: (base) => ({
          ...base,
          minWidth: '140px',
          width: 'auto'
        }),
        menu: (base) => ({
          ...base,
          minWidth: '210px'
        })
      }}
      options={uiStore.dataSourceSelect}
      value={uiStore.dataSourceSelect.find(option => option.value === rightSidebarStore.populationDataset)}
      defaultValue={uiStore.dataSourceSelect[0]}
      onChange={(selectedOption) => {
        if (!selectedOption || selectedOption.value === rightSidebarStore.populationDataset) {
          return
        }
        if (rightSidebarStore) {
          rightSidebarStore.setPopulationDataset(selectedOption.value)
        }
      }}
    />
  )
}

export default inject('uiStore', 'rightSidebarStore')(observer(DataSourceSelect))
